const STORAGE_KEY_HIGH_SCORE = 'vip_tray_highscore_v1';
const STORAGE_KEY_SOUND_MUTED = 'vip_tray_sound_muted';
const STORAGE_KEY_LANGUAGE = 'vip_tray_language';
const STORAGE_KEY_SELECTED_GIRL = 'vip_tray_selected_girl';
const STORAGE_KEY_ANALYTICS = 'vip_tray_analytics_enabled';

export type Language = 'ru' | 'en';

export class StorageService {
  public static getHighScore(): number {
    try {
      const val = localStorage.getItem(STORAGE_KEY_HIGH_SCORE);
      return val ? parseInt(val, 10) || 0 : 0;
    } catch {
      return 0;
    }
  }

  public static setHighScore(score: number): boolean {
    try {
      const current = this.getHighScore();
      if (score > current) {
        localStorage.setItem(STORAGE_KEY_HIGH_SCORE, score.toString());
        return true;
      }
    } catch {
      // Ignore Safari private browsing storage errors
    }
    return false;
  }

  public static isSoundMuted(): boolean {
    try {
      return localStorage.getItem(STORAGE_KEY_SOUND_MUTED) === 'true';
    } catch {
      return false;
    }
  }

  public static setSoundMuted(muted: boolean): void {
    try {
      localStorage.setItem(STORAGE_KEY_SOUND_MUTED, muted ? 'true' : 'false');
    } catch {
      // Ignore
    }
  }

  public static getLanguage(): Language {
    try {
      const val = localStorage.getItem(STORAGE_KEY_LANGUAGE);
      if (val === 'ru' || val === 'en') {
        return val;
      }
    } catch {
      // Ignore Safari private browsing storage errors
    }
    return 'ru';
  }

  public static setLanguage(lang: Language): void {
    try {
      localStorage.setItem(STORAGE_KEY_LANGUAGE, lang);
    } catch {
      // Ignore
    }
  }

  public static getSelectedGirl(): string {
    try {
      const val = localStorage.getItem(STORAGE_KEY_SELECTED_GIRL) || 'random';
      if (val === 'pinup-cyan') {
        localStorage.setItem(STORAGE_KEY_SELECTED_GIRL, 'random');
        return 'random';
      }
      return val;
    } catch {
      return 'random';
    }
  }

  public static setSelectedGirl(modelId: string): void {
    try {
      localStorage.setItem(STORAGE_KEY_SELECTED_GIRL, modelId);
    } catch {
      // Ignore
    }
  }

  public static isAnalyticsEnabled(): boolean {
    try {
      const val = localStorage.getItem(STORAGE_KEY_ANALYTICS);
      return val === null ? true : val === 'true';
    } catch {
      return true;
    }
  }

  public static setAnalyticsEnabled(enabled: boolean): void {
    try {
      localStorage.setItem(STORAGE_KEY_ANALYTICS, enabled ? 'true' : 'false');
    } catch {
      // Ignore
    }
  }
}

